export default defineNuxtRouteMiddleware(async (to) => {
    if (to.name === 'task_category_without_city' || to.name === 'master_category_without_city') {
        // Используем синхронный способ получения данных о пользователе для SSR
        const userStore = useUserStore()
        await nextTick()
        const citySlug = userStore.currentCity?.slug || 'dubai'

        let newRouteName = 'task_category'
        if(to.name === 'task_category_without_city') {
            newRouteName = 'task_category'
        } else if(to.name === 'master_category_without_city') {
            newRouteName = 'master_category'
        }
        
        return navigateTo({
            name: newRouteName,
            params: {
                city: citySlug,
                slug: to.params.slug
            }
        }, { 
            redirectCode: 301,
            external: false
        })
    }
}) 